import React, { Component } from 'react';
import { Menu } from 'antd';
import {Link, graphql, useStaticQuery} from 'gatsby'


const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const LeftMenu = (props) => {

  const data = useStaticQuery(graphql`
  query{
    allContentfulProgram{
      edges{
        node{
          id
          slug
          title
          technicalTrack{
            id
            title
            courses{
              id
              quarter
              title
              courseNumber
              textBooks{
                  title
                  authors
                  url
                }
                referenceBooks{
                  title
                  authors
                  url
                }
                certification{
                  title
                  offeringCompany
                  url
                }
                sections{
                  title
                  serialNumber
                  weeks
                  quiz{
                    title
                    week
                  }
                  lineItem{
                    title
                    shortDescription{
                      shortDescription
                    }
                  }
                }
          }
          }
          innovationTrack{
            id
            title
            courses{
              id
              quarter
              title
              courseNumber
              textBooks{
                  title
                  authors
                  url
                }
                referenceBooks{
                  title
                  authors
                  url
                }
                certification{
                  title
                  offeringCompany
                  url
                }
                sections{
                  title
                  serialNumber
                  weeks
                  quiz{
                    title
                    week
                  }
                  lineItem{
                    title
                    shortDescription{
                      shortDescription
                    }
                  }
                }
          }
          }
          appDevelopmentTrack{
            id
            title
            courses{
              id
              quarter
              title
              courseNumber
              textBooks{
                  title
                  authors
                  url
                }
                referenceBooks{
                  title
                  authors
                  url
                }
                certification{
                  title
                  offeringCompany
                  url
                }
                sections{
                  title
                  serialNumber
                  weeks
                  quiz{
                    title
                    week
                  }
                  lineItem{
                    title
                    shortDescription{
                      shortDescription
                    }
                  }
                }
          }
          }
         }
      }
    }
  }
  `)

const program = data.allContentfulProgram.edges;
  return (
       
			<Menu  mode={props.mode} defaultSelectedKeys={['mail']} id="menuu">
      	<Menu.Item key="mail">
        <Link to="/about-us">About</Link>
        </Menu.Item>
        <SubMenu className="submenuu" title={<span>Available Programs</span>}>
          <MenuItemGroup className="menugroup-li">
          {
              program.map((p, i)=>(
                <Menu.Item key={`setting:${i+1}`} className="dp-li"><Link to={`/program-track/${p.node.slug}`} state={{program, id: i,}} >{p.node.title}</Link></Menu.Item>
              ))
            }
            </MenuItemGroup>
        </SubMenu>
             <Menu.Item key="2" className="dp-li"><Link to="/courses">Courses</Link></Menu.Item>
            <Menu.Item key="3" className="dp-li"><Link to="/faq">FAQ</Link></Menu.Item>
            <Menu.Item key="4" className="dp-li"><Link to="/contact">Contact</Link></Menu.Item>
      </Menu>
       

    );
  }

export default LeftMenu;
